import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router doesn't reset scroll position on navigation by default, without
// this, a new page can render already scrolled to wherever the previous page
// left off. Mounted once in App.js, inside the Router.
//
// `search` is in the dep list alongside `pathname` because detail pages here
// key off a query param (/NewsDetail?slug=...), so story-to-story navigation
// never changes the pathname and would otherwise skip the scroll reset.
const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
